import bg from '../assets/bg.png';
import gallery01 from '../assets/gallery01.jpg';
import gallery02 from '../assets/gallery02.jpg';
import gallery03 from '../assets/gallery03.jpg';
import gallery04 from '../assets/gallery04.jpg';
import gallery05 from '../assets/gallery05.jpg';
import gallery06 from '../assets/gallery06.jpg';
import gallery07 from '../assets/gallery07.jpg';
import gallery08 from '../assets/gallery08.jpg';
import gallery09 from '../assets/gallery09.jpg';
import gallery10 from '../assets/gallery10.jpg';
import gallery11 from '../assets/gallery11.jpg';
import knife from '../assets/knife.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.png';
import findus from '../assets/findus.png';
import pauls_place from '../assets/pauls_place.png';
import P from '../assets/P.png';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  bg,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  gallery07,
  gallery08,
  gallery09,
  gallery10,
  gallery11,
  knife,
  overlaybg,
  spoon,
  welcome,
  findus,
  pauls_place,
  P,
};
